// extracted by mini-css-extract-plugin
module.exports = {"avgReviews":"AvgRating_avgReviews__gQufe","reviewCount":"AvgRating_reviewCount__00fq8","allReviews":"AvgRating_allReviews__NuMMM"};